// Mapview.js -- component
export const DRAWING_NONE = 0;
export const DRAWING_SPLIT_SCREEN = 1;
export const DRAWING_LINE_PROFILE = 2;
export const DRAWING_SQUARE_POLYGON = 3;
export const DRAWING_MAP_MARKER = 4;
export const DRAWING_VOLUME_TOOL = 5;

// export const URL_PREFIX = "http://192.168.1.125/files/";
export const URL_PREFIX = "http://34.227.20.79/files/";